import styled, { css } from 'styled-components';

import Paper from '../../components/Paper/Paper.styled';
import Heading from '../Heading/Heading.styled';

const BORDER_COLOR = '#dbdbdb';

export const CardWrapperStyled = styled(Paper)`
  display: flex;
  min-height: 300px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      flex-direction: column;
    }
  `}
`;

export const Divider = styled.div`
  width: 50px;
  height: 1px;
  margin: 10px 0 10px;

  background: ${BORDER_COLOR};
`;

export const MetadataWrapperStyled = styled.div(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.small};
  `
);

export const MetadataItemStyled = styled.div`
  width: 50%;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.semibold};
  `}
`;

export const MetadataRowStyled = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: 5px;

    & + & {
      margin-top: 10px;
    }

    ${theme.devices.touch} {
      display: block;

      ${MetadataItemStyled} {
        width: 100%;
      }
    }
  `
);

export const MetadataLabelStyled = styled.span(
  ({ theme }) => css`
    color: #515151;
    font-weight: ${theme.fontWeights.normal};

    font-size: ${theme.fontSizes.small};
  `
);

export const ShortDescriptionWrapperStyled = styled.div`
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid ${BORDER_COLOR};

  ${({ theme }) => `
    p {
      font-size: ${theme.fontSizes.small};
      margin-bottom: 0;
      margin-top: 0;
    }
  `}
`;

export const ImageStyled = styled.img`
  width: 220px;
  object-fit: cover;
  border-radius: 4px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      width: 100%;
      height: 300px;
    }
  `}
`;

export const LeftColStyled = styled.div`
  padding: 10px;
  display: flex;
  flex: 1;
  gap: 15px;

  & > div {
    flex: 1;
  }

  ${({ theme }) => `
    ${theme.devices.mobile} {
      flex-direction: column;
    }
  `}
`;

export const RightColStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 190px;
  width: 100%;
  padding: 10px;

  border-left: 1px solid ${BORDER_COLOR};

  ${({ theme }) => `
    ${theme.devices.mobile} {
      border-top: 1px solid ${BORDER_COLOR};
      border-left: none;
      max-width: 100%;
    }
  `}
`;

export const DescriptionStyled = styled.div`
  margin: 15px;
  max-height: 350px;
  overflow: auto;
`;

export const PopupImageStyled = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
  display: inline-block;
`;

export const SustainableActionDetailsStyled = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  background: url('/images/sa-card-bg.png') no-repeat;
  background-size: cover;
  background-position: center;
  max-width: 350px;
  width: 100%;
`;

export const ImageWrapperStyled = styled.div`
  height: 320px;
  margin: 15px 0;
  position: relative;
`;

export const GoalStyled = styled.div`
  max-width: 250px;
  padding: 20px 10px 10px 25px;

  ${({ theme }) => `
    color: ${theme.whiteColour};
    font-weight: ${theme.fontWeights.semibold};
  `}
`;

export const RowStyled = styled.div`
  padding: 0 10px 0 25px;
  margin-top: 15px;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.medium};

    ${theme.devices.mobile} {
      margin-top: 10px;
    }
  `}
`;

export const OwnerNameStyled = styled.div`
  color: #5cb980;
  padding-bottom: 10px;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.semibold};
  `}
`;

export const DetailsTitleStyled = styled(Heading)`
  color: #000;
`;
